import { gql } from '@apollo/client'

export const GET_WORKFLOWS = gql`
  query {
    workflows {
      id
      name
      active
      approval_stages {
        id
        order_number
        is_payment_stage
        approver_role {
          id
          name
          scope
        }
      }
    }
  }
`

export const CREATE_WORKFLOW = gql`
  mutation CreateWorkflow($input: WorkflowInput!) {
    createWorkflow(input: $input) {
      name
      active
    }
  }
`

export const UPDATE_WORKFLOW = gql`
  mutation UpdateWorkflow($id: ID!, $input: WorkflowInput!) {
    updateWorkflow(id: $id, input: $input) {
      id
      name
      active
    }
  }
`

export const DELETE_WORKFLOW = gql`
  mutation DeleteWorkflow($id: ID!) {
    deleteWorkflow(id: $id)
  }
`
